// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2poLE","icon":"styles_icon__1x18V"};